import styled from 'styled-components';

import SharedText from '../text';
import { Colors } from 'src/utils/color';

export const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
`;

export const ContentWrapper = styled.div`
    width: 100%;
    min-height: calc(100vh - 65px - 80px);
    display: flex;
`;

export const LeftBarContainer = styled.div`
    width: 64px;
    background: ${Colors.theme.page_background};
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: solid;
    border-color: ${Colors.extra.white};
    position: relative;
`;

export const Content = styled.div`
    flex: 1;
    padding-top: 12px;
    padding-bottom: 20px;
    background-color: ${Colors.theme.page_background};
    overflow-y: auto;
    width: 97vw;
`;

export const IconButton = styled.a`
    width: 64px;
    height: 64px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    
    /* Remove any default link styling */
    text-decoration: none;
    color: inherit;
    
    /* Ensure no borders or outlines */
    border: none;
    outline: none;
    
    /* Remove any potential link underlines */
    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        border: none;
        outline: none;
    }
`;

export const Topbar = styled.div`
    width: 100%;
    height: 65px;
    background: ${Colors.theme.secondary};
    display: flex;
    padding-top: 9px;
    padding-bottom: 9px;
    align-items: center;
`;

export const Icons = styled.img`
    max-width: 217px;
    max-height: 47px;
    width: auto;
    height: auto;
    object-fit: contain;
    margin-left: 8px;
    margin-right: 40px;
`;

export const Text = styled(SharedText)`
    margin-right: 16px;
    cursor: pointer;
    font-size: 13px;
`;

export const RightNavWrapper = styled.div`
    height: 100%;
    margin-left: auto;
    display: flex;
    align-items: center;
`;

export const NavIconWrapper = styled.div`
    width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PlayIconWrapper = styled.div`
    height: 25px;
    width: 23px;
    border: solid;
    border-color: ${Colors.extra.black};
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IconStyle = {
    marginRight: '16px'
};

export const BrainIcon = styled.span`
    font-size: 20px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    
    /* Remove any potential emoji rendering artifacts */
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    
    /* Ensure no extra spacing or lines */
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    
    /* Override any inherited link styles */
    text-decoration: none;
    
    /* Force remove any potential underline or border */
    &::after,
    &::before {
        content: none;
        display: none;
        border: none;
        outline: none;
        text-decoration: none;
    }
    
    /* Additional aggressive styling to remove any lines */
    background: transparent;
    box-shadow: none;
    filter: none;
    transform: none;
    
    /* Ensure no text decoration or underlines */
    text-decoration-line: none;
    text-decoration-style: none;
    text-decoration-color: transparent;
    text-decoration-thickness: 0;
    
    /* Remove any potential emoji-specific styling */
    font-family: inherit;
    font-weight: inherit;
    font-style: inherit;
`;

export const Menu = styled.div<{ isOpen: boolean; width?: number }>`
    position: absolute;
    right: 10px;
    top: 50px;
    background-color: ${Colors.dropdown.dropdown_bg};
    border-radius: 4px;
    align-items: flex-start;
    padding: 13px 15px;
    gap: 10px;
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
    flex-direction: column;
    min-width: ${(props) => props.width}px;
    z-index: 1;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

export const SettingMenu = styled.div<{ isOpen: boolean; width?: number }>`
    left: 65px;
    position: absolute;
    top: 0px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 20px;
    align-items: center;
    padding: 24px 28px;
    gap: 16px;
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
    flex-direction: column;
    min-width: ${(props) => props.width || 240}px;
    z-index: 1000;
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.12), 0 12px 24px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(12px);

    &::before {
        content: '';
        position: absolute;
        top: -10px;
        left: 24px;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #ffffff;
        filter: drop-shadow(0 -3px 6px rgba(0, 0, 0, 0.12));
    }
`;

export const Item = styled.div`
    height: 56px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 200px;
    padding: 0 24px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
        transition: left 0.6s ease;
    }
    
    &:hover {
        background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
        transform: translateY(-3px);
        box-shadow: 0 12px 32px rgba(102, 126, 234, 0.35);
        border-color: rgba(255, 255, 255, 0.25);
        
        &::before {
            left: 100%;
        }
    }
    
    &:active {
        transform: translateY(-1px);
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.25);
    }
    
    /* Text styling for child elements */
    p {
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
        letter-spacing: 0.4px;
        font-weight: 600;
        font-size: 14px;
    }
`;

export const EmptyView = styled.div`
    display: flex;
    flex: 1;
    width: 64px;
`;
